module.exports = __webpack_public_path__ + "media/src/images/icons/location-3bb43f94487e88ddf23f9903532c4282.svg";